import { render, staticRenderFns } from "./Danger.vue?vue&type=template&id=5973b518&"
import script from "./Danger.vue?vue&type=script&lang=js&"
export * from "./Danger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports